var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V72H72V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 54V18C0 8.1 8.1 0 18 0H54C63.9 0 72 8.1 72 18V54C72 63.9 63.9 72 54 72H18C8.1 72 0 63.9 0 54Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.21 18.195V25.0571C25.8718 25.0723 33.215 28.1261 38.6295 33.5488C44.044 38.9715 47.088 46.3207 47.0941 53.985H54C53.9893 44.4947 50.2146 35.3964 43.5045 28.6874C36.7944 21.9784 27.6972 18.2068 18.21 18.2007V18.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.21 30.4389V37.2705C22.6348 37.2781 26.8756 39.0428 30.0006 42.1769C33.1256 45.311 34.8793 49.5581 34.8762 53.985H41.756C41.75 47.747 39.2724 41.7659 34.8664 37.3522C30.4603 32.9386 24.485 30.4526 18.2501 30.4389H18.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9021 44.5666C21.9714 44.57 21.0626 44.849 20.2905 45.3685C19.5183 45.888 18.9173 46.6247 18.5635 47.4855C18.2097 48.3463 18.1189 49.2926 18.3025 50.205C18.4862 51.1174 18.936 51.9549 19.5953 52.6117C20.2546 53.2686 21.0937 53.7155 22.0067 53.8958C22.9198 54.0761 23.8657 53.9818 24.7252 53.6249C25.5847 53.268 26.3192 52.6644 26.8359 51.8903C27.3526 51.1163 27.6284 50.2065 27.6284 49.2758C27.6239 48.0253 27.1239 46.8275 26.2381 45.9448C25.3522 45.0622 24.1526 44.5666 22.9021 44.5666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.eec56a083c956c5d709461f8d1e77076.svg";
export { ForwardRef as ReactComponent };